export const SET_NODE="SET_NODE";
export const ADD_NODE="ADD_NODE";
export const ADD_BRANCH="ADD_BRANCH";
export const DEL_NODE="DEL_NODE";
export const UP_NODE="UP_NODE";
export const UP_MAP="UP_MAP";



// WEBPACK FOOTER //
// ./src/components/packages/store/mutation-types.js